/* eslint-disable react/react-in-jsx-scope */
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonMenuButton,
  IonTitle,
  IonContent,
} from "@ionic/react";
import { useEffect } from "react";
import { getToken } from "../utils/utils";

const enPage: React.FC = () => {
  const token = getToken();

  //   useEffect(() => {});

  return (
    <IonPage id="enPage">
      <IonHeader>
        <IonToolbar className="customBg">
          <IonButtons slot="start">
            <IonMenuButton className="txtW" />
          </IonButtons>
          <IonTitle>
            <strong className="txtW">Super Admin - Encuestas</strong>
          </IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen className="cIframe">
        <iframe src="https://encuestapp.elfuerte.online/"></iframe>
      </IonContent>
    </IonPage>
  );
};

export default enPage;
